<template>
    <div id="wrapper" class="info-table">
        <!--======================================================
                        Header
                ======================================================-->
        <pages-header></pages-header>

        <second-header></second-header>

        <!--======================================================
                        Main Content
                ======================================================-->
        <div class="mainContainer custom-container">
            <div class="content">
                <div class="container-fluid">
                    <div class="title">
                        <h6>{{i18n('Checkout')}}</h6>
                    </div>
                    <form action="" class="form" id="form" @submit.prevent="save()" autocomplete="off">
                        <div class="base_box_cnt full-height">
                            <h6 class="cnt_title">{{i18n('Passengers')}}</h6>
                            <div class="row" v-for="(seat, k) in selectedSeats">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="fio">{{i18n('FULL NAME')}}<span class="red-txt">*</span></label>
                                        <input type="text" class="form-control" autocomplete="off" v-model="form.passengers[k].full_name" id="fio" @keyup="handleKeyup">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="phone">{{i18n('Phone')}}  <span class="red-txt">*</span></label>
                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">+998</div>
                                            </div>
                                            <masked-input mask="11 111 11 11" autocomplete="off" class="form-control num" v-model="form.passengers[k].phone" id="phone"
                                                          @input="handleKeyup"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="email">{{i18n('E-mail')}}</label>
                                        <input type="text" class="form-control" autocomplete="off" v-model="form.passengers[k].email" id="email">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <p class="text-danger text-small mb-0">* -   {{i18n('required fields')}}</p>
                            </div>
                            <div class="middle-box"></div>
                            <div class="bottom-box">
                                <div class="row align-items-center">
                                    <div class="offset-sm-4 col-sm-4">
                                        <button type="submit" form="form" :disabled="disabled" class="btn btn-primary float-right w-100">{{i18n('For paying')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    import PagesHeader from "../components/PagesHeader";
    import SecondHeader from "../components/SecondHeader";
    import FormService from '../services/FormService';
    import MaskedInput from 'vue-masked-input';

    export default {
        name: "Data",
        components: {SecondHeader, PagesHeader, MaskedInput},
        data() {
            return {
                selectedSeats: [],
                disabled: true,
                form: new FormService({
                    passengers: [],
                }),
                orderForm: new FormService({
                    amount: 0,
                    tax: 0,
                    passengers: [],
                    trip_id: null
                }),
                loadingState: false
            }
        },
        created() {
            let store = this.$store.state;
            if (!store.date.date) {
                this.$router.back();
            }
            this.orderForm.trip_id = this.$store.state.selectedTrip.id;
            this.selectedSeats = this.$store.state.selectedSeats;
            let amount = 0;
            this.selectedSeats.forEach(item => {
                let singleAmount = parseInt(this.$store.state.selectedTrip.price);
                this.form.passengers.push({
                    departure_station_id: this.$store.state.from.id,
                    arrival_station_id: this.$store.state.to.id,
                    order_id: null,
                    ticket_id: null,
                    tariff_id: this.$store.state.selectedTrip.tariff_id,
                    trip_id: this.$store.state.selectedTrip.id,
                    seat_number: item.index,
                    amount: singleAmount,
                    full_name: '',
                    phone: ''
                });
                amount += singleAmount;
            });
            let taxAmount = 0;
            this.$store.state.taxes.forEach(tax => {
                taxAmount += tax.price;
            });
            this.orderForm.amount = amount;
            this.orderForm.tax = taxAmount;
        },
        methods: {
            save() {
                if (this.disabled) {
                    return;
                }
                this.loadingState = true;
                this.form.passengers.forEach(item => {
                    this.orderForm.passengers.push(item.seat_number);
                });
                this.orderForm.post('/infokiosk/store-order')
                    .then(res => {
                        let data = res.data;
                        this.form.passengers.forEach(item => {
                            item.order_id = data.id
                        });
                        if (!res.errors) {
                            this.form.post('/infokiosk/store-passenger')
                                .then(res => {
                                    if (!res.errors) {
                                        this.$store.state.order = data;
                                        this.$store.state.passengers = this.form.passengers;
                                        this.$router.push({name: 'web-payment'});
                                    } else {
                                        alert('System error try again');
                                        this.$router.push({name: 'web'});
                                    }
                                })
                        } else {
                            let text = 'Ошибка! Некоторые места уже заняты. Занятые места: ';
                            if (res.errors.seats.length > 0) {
                                res.errors.seats.forEach(seat => {
                                    text += (seat + ' ');
                                });
                                alert(text);
                                this.$router.push({name: 'web-tickets'});
                            }
                        }
                    })
                    .finally(() => {
                        this.loadingState = false;
                    })
            },
            handleKeyup() {
                this.form.passengers.forEach(item => {
                    this.disabled = item.full_name === '' || !parseInt(item.phone) > 0;
                });
            }
        },
    }
</script>
<style>
    .red-txt {
        color: red;
    }

    .text-small {
        font-size: 18px;
    }
</style>
